export default __webpack_public_path__ + "static/media/icons8-instagram1.499956db.svg";